/**
 * Created by Kristy on 2/8/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('sectorClinicNames', {
                parent: 'sectorView',
                url: '/clinicNames',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_REC_ADMINISTRATOR', 'ROLE_REC_FRONT_DESK'],
                    pageTitle: 'sigmaCrmApp.customer.home.title'
                },
                templateUrl: 'app/displays/sectors/clinicNames/clinicNames.html',
                controller: 'SectorClinicNamesController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    entity: ['$stateParams', 'Sector', function($stateParams, Sector) {
                        return Sector.get({id : $stateParams.id});
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
